import actions from './actions';
import mutations from './mutations';
import getters from './getters';

function state() {
    return {
        isLoading: false,
        isGeneratingAssets: false,

        formData: {
            media_id: null,
            // NOTE: type should always default to html, since we need the rendered html content form the preview iframe.
            type: 'html',
            content: '',
            html: '',
        },

        preview_image: null,
        preview: '',
        pdfPreview: '',
        testFormDialogOpen: false,
        pdfDialogOpen: false,
        publishAssetsDialogOpen: false
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};